import useScrollReset from 'shared/lib/scroll/useScrollReset';

export const ScrollReset = () => {
  useScrollReset();

  return null;
};
